// extracted by mini-css-extract-plugin
export default {"termsOfUseText":"terms-of-use_termsOfUseText__Zs0vu"};